const content = {
    pinterest_data_upload: {
        en: {
            data_type_description: 'Pinterest Data Upload',
            summary_no_video_html: '<p>This is the second part of the Pinterest data task. Please upload your Pinterest data file by following the instructions below:</p>',
            steps: [
              {
                step_type: 'numbered_step',
                number: '1',
                description_html: '<p>You should have received an email notifying you that your data is ready.</p>'
              },
              {
                step_type: 'numbered_step',
                number: '2',
                description_html: '<p>Open the email and tap <b>Click Here to View your Data</b>.</p>'
              },
              {
                step_type: 'numbered_step',
                number: '3',
                description_html: `<p>Enter your email address and verification code.</p>`
              },
              {
                step_type: 'numbered_step',
                number: '4',
                description_html: `<p>Click on the pinterest.zip file.</p>`
              },
              {
                step_type: 'numbered_step',
                number: '5',
                description_html: `<p>Finally, tap Upload below and chose the Pinterest file from your Downloads folder.</p>`
              }
            ],
            part_1_instructions_link: 'https://help.measureprotocol.com/en/support/solutions/articles/80001128767-pinterest-data-file-retro-instructions'
        }
    }
}

export const pinterestDataTypes = {
    pinterest_data_upload: {
        data_type: 'pinterest_data_upload',
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/pinterest/logo.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        require_consent: true,
        generic: {
            ...content.pinterest_data_upload,
        }
    },
}